import React from 'react';

const Blog = () =>{
    return(
        <>
        this page is under development.
        </>
    );
}

export default Blog